import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '平台资讯', path: '/category/platform-news' },
      { label: '游戏攻略', path: '/category/game-guide' },
      { label: '安全指南', path: '/category/security' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', path: '/category/faq-help' },
      { label: '安全登录', path: '/category/security' },
      { label: '使用指南', path: '/category/faq-help' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { label: '在线客服', path: '/about' },
      { label: '客服邮箱', path: '/about' },
      { label: '商务合作', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-star-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                众赢zygjb
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              众赢zygjb官方入口是玩家信赖的正版平台，提供安全稳定的登录通道。我们致力于为每一位玩家打造安全、公平、优质的游戏环境。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="QQ"
              >
                <i className="ri-qq-line text-sm text-background-200"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 众赢zygjb 版权所有 | 本站为官方入口导航页，不提供游戏服务
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">
              隐私政策
            </a>
            <a href="#" className="hover:text-background-300 transition-colors">
              服务条款
            </a>
            <a href="#" className="hover:text-background-300 transition-colors">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}